import React from "react";

const index = () => {
  return (
    <div>
      <h5>this is Mosi</h5>
    </div>
  );
};

export default index;
